export default "__VITE_PUBLIC_ASSET__3c11ee9f__"